// src/lzapp_web_common_code/screens/choosePlans/components/VolumeLicensingBanner.js
import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faEnvelope } from '@fortawesome/free-solid-svg-icons';

const VolumeLicensingBanner = ({ theme }) => {
  const styles = {
    container: {
      background: theme?.background?.blue,
      borderRadius: '1rem',
      padding: '2rem',
      border: `1px solid ${theme?.primary?.blue?.[500]}40`,
      marginBottom: '2rem',
      width: '100%',
    },
    content: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '2rem',
      flexWrap: 'wrap',
    },
    textSection: {
      flex: 1,
      minWidth: '300px',
      display: 'flex',
      alignItems: 'center',
      gap: '1.5rem',
    },
    icon: {
      fontSize: '2.5rem',
      color: theme?.primary?.blue?.[500],
      flexShrink: 0,
    },
    title: {
      fontSize: '1.5rem',
      fontWeight: '700',
      color: theme?.text?.primary,
      marginBottom: '0.5rem',
    },
    subtitle: {
      fontSize: '1rem',
      color: theme?.text?.secondary,
      marginBottom: '1rem',
    },
    features: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
    },
    feature: {
      fontSize: '0.875rem',
      color: theme?.text?.secondary,
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    featureDot: {
      width: '4px',
      height: '4px',
      borderRadius: '50%',
      background: theme?.primary?.blue?.[500],
    },
    ctaButton: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.5rem',
      padding: '1rem 2rem',
      background: theme?.primary?.blue?.[500],
      color: 'white',
      borderRadius: '0.5rem',
      fontSize: '1rem',
      fontWeight: '600',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      textDecoration: 'none',
    },
    ctaButtonHover: {
      background: theme?.primary?.blue?.[600],
      transform: 'translateY(-2px)',
      boxShadow: theme?.shadows?.lg,
    },
  };

  const handleOpenVolumeLicensing = () => {
    window.open('https://licenses.learnzapp.com', '_blank');
  };

  return (
    <motion.div 
      style={styles.container}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.4 }}
    >
      <div style={styles.content}>
        <div style={styles.textSection}>
          <FontAwesomeIcon icon={faUsers} style={styles.icon} />
          <div>
            <h3 style={styles.title}>Need licenses for your team or organization?</h3>
            <p style={styles.subtitle}>
              Save up to 55% off for groups of 5 or more users
            </p>
          </div>
        </div>
        
        <motion.button
          style={styles.ctaButton}
          whileHover={styles.ctaButtonHover}
          whileTap={{ scale: 0.95 }}
          onClick={handleOpenVolumeLicensing}
        >
          
          Explore Volume Licensing
        </motion.button>
      </div>
    </motion.div>
  );
};

export default VolumeLicensingBanner;